import PromiseWorker from "promise-worker";
import SerialWorker from "./SerialWorker.ts?worker";

class ModbusWorker {
  private readonly worker: Worker;
  private promiseWorker: PromiseWorker;

  constructor() {
    this.worker = new SerialWorker();
    this.promiseWorker = new PromiseWorker(this.worker);
  }

  async postMsgOpenPort(portIndex: number, baudRate: number): Promise<string> {
    return this.promiseWorker.postMessage({
      type: "openPort",
      portIndex,
      baudRate,
    });
  }

  async postMsgClosePort() {
    return this.promiseWorker.postMessage({
      type: "closePort",
    });
  }

  async postMsgGetPortState() {
    return this.promiseWorker.postMessage({
      type: "getPortState",
    });
  }

  async postMsgModbusRead(
    deviceAddr: number,
    modbusAddr: number,
    counts: number,
  ) {
    return this.promiseWorker.postMessage({
      type: "modbusRead",
      deviceAddr,
      modbusAddr,
      counts /* count of register (16bits) */,
    });
  }

  async postMsgModbusWrite(
    deviceAddr: number,
    modbusAddr: number,
    counts: number,
    values: Uint8Array,
  ) {
    return this.promiseWorker.postMessage({
      type: "modbusWrite",
      deviceAddr,
      modbusAddr,
      counts /* count of register (16bits) */,
      values,
    });
  }

  async postMsgModbusPollingData(deviceAddr: number) {
    return this.promiseWorker.postMessage({
      type: "modbusPollingData",
      deviceAddr,
    });
  }

  async postMsgModbusLogData(
    deviceAddr: number,
    dt_start: number,
    dt_end: number,
    interval: "minute" | "second" | "ms",
  ) {
    return this.promiseWorker.postMessage({
      type: "modbusLogData",
      deviceAddr,
      dt_start,
      dt_end,
      interval,
    });
  }

  terminate() {
    this.worker.terminate();
  }
}

export default ModbusWorker;
